import { render, staticRenderFns } from "./BriqSubmitButton.vue?vue&type=template&id=5f114ad7&scoped=true&lang=pug&"
import script from "./BriqSubmitButton.vue?vue&type=script&lang=js&"
export * from "./BriqSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./BriqSubmitButton.vue?vue&type=style&index=0&id=5f114ad7&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f114ad7",
  null
  
)

export default component.exports